// extracted by mini-css-extract-plugin
export var closeButton = "_gu-2";
export var closeButtonIcon = "_gu-3";
export var lightboxContent = "_gu-1";
export var lightboxOverlay = "_gu-0";